// const auth = 'ac086df6e4edabc1e0fa8f8eab6be2f4';

export const POPULAR_ALL_API =
    "https://api.themoviedb.org/3/trending/all/day?api_key=ac086df6e4edabc1e0fa8f8eab6be2f4&page=1";

export const TV_API =
    "https://api.themoviedb.org/3/trending/tv/day?api_key=ac086df6e4edabc1e0fa8f8eab6be2f4&page=1";

export const MOVIE_API =
    "https://api.themoviedb.org/3/trending/movie/day?api_key=ac086df6e4edabc1e0fa8f8eab6be2f4&page=1";

export const Img_API = "https://image.tmdb.org/t/p/w1280";

export const SEARCH_API =
    "https://api.themoviedb.org/3/search/movie?api_key=ac086df6e4edabc1e0fa8f8eab6be2f4&query=";
